import { render, staticRenderFns } from "./CartProductErrorText.vue?vue&type=template&id=b08bce18&"
import script from "./CartProductErrorText.vue?vue&type=script&lang=js&"
export * from "./CartProductErrorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports